import React, { Fragment } from "react";
import Modal from "react-modal";
import ImageGallery from "react-image-gallery";

import ReactPlayer from "react-player";

import CircleLoader from "react-spinners/CircleLoader";
import { css } from "@emotion/react";
import { FaPause, FaPlay } from "react-icons/fa";

//css
import "react-image-gallery/styles/css/image-gallery.css";

import "./choosepage.css";
//icons
import musicIcon from "../../assets/icons/music.png";
import otherIcon from "../../assets/icons/autre.png";
import texteIcon from "../../assets/icons/texte.png";
import videoIcon from "../../assets/icons/video.png";

//tempVignette TODO

import { ReactComponent as LeftArrow } from "../../assets/icons/nav/arrowleft.svg";
import { ReactComponent as RightArrow } from "../../assets/icons/nav/arrowright.svg";
const lastSegment = window.location.href.substring(
	window.location.href.lastIndexOf("/") + 1
);
// Remplacement des URLs codées en dur par des variables d'environnement
const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;
const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;
const bckgrnddef = PUBLIC_URL + "/img/appbackground/p";
const loaderStyle = css`
	position: relative;
	top: 40%;
	left: 30%;
	display: block;
	border-color: red;

	z-index: 20;
`;
const containerStyle = {
	backgroundImage: "url(" + bckgrnddef + lastSegment + ".jpg)",
};

class Choosepage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			contentPages: [
				12, 14, 19, 23, 30, 56, 60, 62, 74, 89, 90, 98, 104, 107, 108, 111, 116,
				118, 120, 122, 125, 129, 130, 131, 133, 135, 137, 142, 150, 162, 167,
				168, 169, 170, 173, 179, 180, 185, 198, 200, 202, 209, 213, 214, 219,
				229, 230, 232, 235, 237, 242,
			],
			nextPage: 0,
			contents: [],
			currentContent: [],
			showModal: false,
			song: null,
			audioPlaying: false,
			defaultChecked: false,
			songtime: "--",
			songduration: "--",
			checked: false,
		};
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.handleReturn = this.handleReturn.bind(this);
		this.playPauseAudio = this.playPauseAudio.bind(this);
		this.handleNext = this.handleNext.bind(this);
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}
	//helper
	fmtMSS(s) {
		return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
	}

	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener("resize", this.updateWindowDimensions);
		const currentPage = parseInt(lastSegment);
		this.setState({
			nextPage:
				this.state.contentPages[
					this.state.contentPages.indexOf(currentPage, 0) + 1
				],
		});
		fetch(STRAPI_URL + "/mediacontents")
			.then((res) => res.json())
			.then((result) => {
				const filtered = result.filter(
					(result) => result.relatedPage === parseInt(lastSegment)
				);
				this.setState({
					contents: filtered,
					modalIsOpen: false,
				});
			})
			.then(() => {
				setTimeout(() => {
					this.setState({ isLoading: false });
				}, 1000);
			});
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.updateWindowDimensions);
	}
	componentDidUpdate() {}
	updateWindowDimensions() {
		this.setState({ width: window.innerWidth, height: window.innerHeight });
	}

	openModal(content) {
		this.setState({ currentContent: content });

		if (content.audioAvailable) {
			const song = new Audio(content.audioUrl);
			song.addEventListener(
				"timeupdate",
				(event) => {
					const currentTime = this.fmtMSS(Math.floor(song.currentTime));
					const duration = this.fmtMSS(Math.floor(song.duration));
					this.setState({ songtime: currentTime });
					this.setState({ songduration: duration });
				},
				false
			);
			this.setState({ song: song });
		}

		this.setState({ showModal: true });
	}

	closeModal() {
		if (this.state.song !== null) {
			this.state.song.pause();
			this.setState({ song: null });
		}

		this.setState({ audioPlaying: false });
		this.setState({ showModal: false });
	}
	handleReturn() {
		window.location.href = "/home";
	}
	handleNext() {
		const next = this.state.nextPage;
		console.log(next);
		if (next === 242) {
			window.location.href = "https://www.christineaymon.ch/biographie/";
		} else {
			window.location.href = "/choosepage/" + next;
		}
	}

	playPauseAudio() {
		const isPlaying = this.state.audioPlaying;

		if (isPlaying) {
			this.state.song.pause();
		} else {
			this.state.song.play();
		}

		this.setState({ audioPlaying: !isPlaying });
	}

	render() {
		return (
			<>
				{this.state.isLoading && (
					<div className="loaderContainer">
						<CircleLoader
							color={"red"}
							loading={this.state.isLoading}
							size={150}
							css={loaderStyle}
						/>
					</div>
				)}
				<div id="backgroundBlur" style={containerStyle}></div>
				<div id="choosepageContainer">
					<div className="choosepageNavigation">
						<button className="returnButton" onClick={this.handleReturn}>
							<LeftArrow /> N°
						</button>
						<p className="NavigationDetails">page {lastSegment}</p>
						<button className="nextButton" onClick={this.handleNext}>
							<RightArrow /> {this.state.nextPage}
						</button>
					</div>
					<div id="cardList">
						{this.state.contents.map((content) => (
							<div
								key={content.id}
								className="cardContainer"
								onClick={() => this.openModal(content)}
							>
								<div className="collumnFlex1">
									<div className="cardImageContainer">
										<img
											className="cardImage"
											src={
												PUBLIC_URL +
												"/img/vignettes/" +
												content.vignetteUrl +
												".jpg"
											}
											alt=""
										></img>
									</div>
								</div>
								<div className="collumnFlex2">
									<h2 className="cardTitle">{content.Title}</h2>
									<p className="cardAuthor">De: {content.author}</p>
									{content.reader != null && (
										<p className="cardReader">Lu par: {content.reader}</p>
									)}{" "}
									{content.reader === null && (
										<p className="cardReader phantom"> test</p>
									)}
									<div className="cardDivider"></div>
									<div className="cardIconsContainer">
										{content.audioAvailable === true && (
											<div className="iconGrp">
												<img className="cardIcon" src={musicIcon} alt="" />
												<p className="iconDescr">Audio</p>
											</div>
										)}
										{content.videoAvailable === true && (
											<div className="iconGrp">
												<img className="cardIcon" src={videoIcon} alt="" />
												<p className="iconDescr">Vidéo</p>
											</div>
										)}
										{content.textAvailable === true && (
											<div className="iconGrp">
												<img className="cardIcon" src={texteIcon} alt="" />
												<p className="iconDescr">Texte</p>
											</div>
										)}

										{content.otherAvailable === true && (
											<div className="iconGrp">
												<img className="cardIcon" src={otherIcon} alt="" />
												<p className="iconDescr">Autre</p>
											</div>
										)}
									</div>
								</div>
							</div>
						))}
					</div>

					{/* Modal */}
					<Modal
						closeTimeoutMS={2000}
						className="Modal"
						ariaHideApp={false}
						isOpen={this.state.showModal}
						onAfterOpen={this.afterOpenModal}
						onRequestClose={this.closeModal}
					>
						<div className="modalNavigation">
							<button className="closeModalButton" onClick={this.closeModal}>
								<LeftArrow /> {this.state.currentContent.relatedPage}
							</button>
							<p className="modalNavigationDetails">
								page {this.state.currentContent.relatedPage} |{" "}
								{this.state.currentContent.Title}
							</p>
						</div>
						{/* Only text case */}
						{this.state.currentContent.textAvailable === true &&
							this.state.currentContent.audioAvailable === false &&
							this.state.currentContent.videoAvailable === false && (
								<>
									<div className="modalTextContainer">
										<h2 className="modalTextTitle">
											{this.state.currentContent.Title}
										</h2>
										<p className="modalTextAuthor">
											De: {this.state.currentContent.author}
										</p>
										<p className="modalText">
											{this.state.currentContent.textContent}
										</p>
									</div>
								</>
							)}
						{/* Only video case */}
						{this.state.currentContent.audioAvailable === false &&
							this.state.currentContent.videoAvailable === true && (
								<>
									<ReactPlayer
										className="videoPlayer"
										url={
											"https://www.youtube.com/watch?v=" +
											this.state.currentContent.youtubeId
										}
										width="100vw"
										height="60vh"
										config={{
											youtube: {
												playerVars: {
													autoplay: 1,
													fs: 1,
													modestbranding: 1,
													rel: 0,
													showinfo: 0,
													controls: 1,
												},
											},
										}}
									/>
									<p className="modalText textVideo">
										{this.state.currentContent.textContent}
									</p>
								</>
							)}

						{/* Only audio case */}
						{this.state.currentContent.textAvailable === false &&
							this.state.currentContent.audioAvailable === true &&
							this.state.currentContent.videoAvailable === false && (
								<>
									<div id="spinnerContainer">
										<div id="firstAudioContainer">
											<div className="morphContainer">
												{this.state.audioPlaying ? (
													<FaPause className="pauseIcon" />
												) : (
													<FaPlay className="playIcon" />
												)}
											</div>
										</div>
										<div id="secondAudioContainer"></div>
										<div
											id="thirdAudioContainer"
											onClick={this.playPauseAudio}
										></div>
									</div>

									<div className="audioDescr">
										<p className="songtimer">
											<span>Durée: </span>
											{this.state.songtime} / {this.state.songduration}
										</p>
										<p>
											<span>De: </span>
											{this.state.currentContent.author}
										</p>
										{this.state.currentContent.reader !== null && (
											<p>
												<span>Lu par: </span>
												{this.state.currentContent.reader}
											</p>
										)}
									</div>

									{this.state.currentContent.textContent !== null && (
										<div className="modalTextContainer">
											<p className="modalText">
												{this.state.currentContent.textContent}
											</p>
										</div>
									)}
								</>
							)}
						{/* audio + text case*/}
						{this.state.currentContent.textAvailable === true &&
							this.state.currentContent.audioAvailable === true &&
							this.state.currentContent.videoAvailable === false && (
								<>
									<div id="spinnerContainer">
										<div id="firstAudioContainer" onClick={this.playPauseAudio}>
											<div className="morphContainer">
												{this.state.audioPlaying ? (
													<FaPause className="pauseIcon" />
												) : (
													<FaPlay className="playIcon" />
												)}
											</div>
										</div>
										<div id="secondAudioContainer"></div>
										<div id="thirdAudioContainer"></div>
									</div>

									<div className="audioDescr">
										<p className="songtimer">
											<span>Durée: </span>
											{this.state.songtime} / {this.state.songduration}
										</p>
										<p>
											<span>Lu par: </span>
											{this.state.currentContent.reader}
										</p>
									</div>

									<div className="modalTextContainer">
										<h2 className="modalTextTitle">
											{this.state.currentContent.Title}
										</h2>
										<p className="modalTextAuthor">
											De: {this.state.currentContent.author}
										</p>
										<p className="modalText">
											{this.state.currentContent.textContent}
										</p>
									</div>
								</>
							)}
						{/* gallery case*/}
						{this.state.currentContent.textAvailable === false &&
							this.state.currentContent.audioAvailable === false &&
							this.state.currentContent.videoAvailable === false &&
							this.state.currentContent.galleryAvailable === true && (
								<div id="sliderContainer">
									<ImageGallery
										lazyLoad
										showPlayButton={false}
										showThumbnails={false}
										infinite={false}
										useBrowserFullscreen={false}
										swipeThreshold={50}
										items={this.state.currentContent.galleryImages}
									></ImageGallery>
									<div className="modalTextContainer">
										<p className="modalText">
											{this.state.currentContent.textContent}
										</p>
									</div>
								</div>
							)}
					</Modal>
				</div>
			</>
		);
	}
}
export default Choosepage;
